
class BundleFocusHeader
extends HTMLElement {

    controller = new AbortController

    constructor (){

        super()

        this._config = JSON.parse(this.dataset.json)

        console.debug('Config',this._config)
    }

    connectedCallback (){

        const { signal } = this.controller

        const onUpdate = this.updateFocusHeader.bind(this)

        document.addEventListener(
            'bundlePage:updateFocusHeader' ,
            onUpdate , { signal }
        )
    }

    disconnectedCallback (){
        this.controller.abort()
    }

    updateFocusHeader ( event ){

        const quizData = JSON.parse(event.detail.quiz_data)

        console.debug('BundleFocusHeader::updateFocusHeader',{ quizData })

        console.log(quizData["SKIN_CONCERN_1"]);
        console.log(quizData["SKIN_CONCERN_2"]);
        console.log(quizData["SKIN_CONCERN_3"]);

        const headline = this.querySelector("[data-headline]");
        const name = quizData.first_name ? quizData.first_name : quizData.Octane_Name;
        headline.innerHTML = headline.innerHTML.replace("{name}", name);

        this.querySelector("[data-skin-type]").innerHTML = this._config["skin_type"][quizData.BEAU_SKIN_TYPE];
        this.querySelector("[data-sensivity]").innerHTML = this._config["sensivity"][quizData.BEAU_Sensitivity];

        const concern1 = this.querySelector("[data-concern-1]");
        concern1.querySelector("p").innerHTML = this._config["concerns"][quizData.SKIN_CONCERN_1]["label"];
        concern1.querySelector("img").src = this._config["concerns"][quizData.SKIN_CONCERN_1]["icon"];
        concern1.hidden = false;

        if (this._config["concerns"][quizData.SKIN_CONCERN_2] != undefined) {
            const concern2 = this.querySelector("[data-concern-2]");
            concern2.querySelector("p").innerHTML = this._config["concerns"][quizData.SKIN_CONCERN_2]["label"];
            concern2.querySelector("img").src = this._config["concerns"][quizData.SKIN_CONCERN_2]["icon"];
            concern2.hidden = false;
        }

        if (this._config["concerns"][quizData.SKIN_CONCERN_3] != undefined) {
            const concern3 = this.querySelector("[data-concern-3]");
            concern3.querySelector("p").innerHTML = this._config["concerns"][quizData.SKIN_CONCERN_3]["label"];
            concern3.querySelector("img").src = this._config["concerns"][quizData.SKIN_CONCERN_3]["icon"];
            concern3.hidden = false;
        }

        document.querySelectorAll("[data-dynamic-appearance]").forEach(element => {
            if (element.dataset.defaultAppearance == "show") {
            element.hidden = true;
            } else {
            const dynamicElements = element.querySelectorAll("[concern-one-whitelist]");
            const oneDynamicElementOnly = element.getAttribute("data-one-dynamic-element-only") == "true";
            let dynamicElementShown = false;

            dynamicElements.forEach(dynamicElement => {
                const whiteList = [];
                const blackList = [];
                const skin_concerns = [quizData.SKIN_CONCERN_1, quizData.SKIN_CONCERN_2, quizData.SKIN_CONCERN_3];

                for (let i = 1; i <= 3; i++) {
                const number = i == 1 ? "one" : i == 2 ? "two" : "three";

                const tempWhiteList = dynamicElement.getAttribute(`concern-${number}-whitelist`).split(",");
                const tempBlackList = dynamicElement.getAttribute(`concern-${number}-blacklist`).split(",");

                whiteList.push(tempWhiteList == "" ? [] : tempWhiteList);
                blackList.push(tempBlackList == "" ? [] : tempBlackList);
                }

                let hidden = null;
                let whiteListEmpty = true;

                for (let i = 0; i < 3; i++) {
                if (whiteList[i].length > 0) {
                    whiteListEmpty = false;
                    if (whiteList[i].includes(skin_concerns[i])) {
                    hidden = false;
                    }
                }
                if (blackList[i].length > 0) {
                    if (blackList[i].includes(skin_concerns[i])) {
                    hidden = true;
                    }
                }
                }

                if (whiteListEmpty && hidden == null) {
                hidden = false;
                }

                if (!oneDynamicElementOnly || dynamicElementShown == false) {
                if (hidden == true) {
                    dynamicElement.hidden = true;
                } else if (hidden == false) {
                    dynamicElement.hidden = false;
                    dynamicElementShown = true;
                }
                }
            });
            element.hidden = false;
            }
        })
    }
}


customElements.define(
    'bundle-focus-header' ,
    BundleFocusHeader
)
